//Material ui
import {
    Button,
    Dialog,
    DialogActions
} from "@mui/material";

//Estilo
import { useNavigate } from "react-router";

//Interface de la entrada del componente
interface PropsInterface {
    open: boolean
    text: string
    quantity: number
    type: 'error' | 'success'
    onClose?: () => void
}
const DialogConfirmation = (props: PropsInterface) => {
    const navigate = useNavigate()

    const hiddenDialog = () => {
        if ( props.type === 'success' ) {
            navigate(props.quantity)
        } else if ( props.onClose ) {
            props.onClose()
        }
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 2,
                    maxWidth: 440,
                    width: '90%'
                }
            }}
        >
            <div style={{ width: "100%", textAlign: "center", paddingTop: '8px' }}>
                <div style={{ width: "95%", margin: "auto", fontSize: "1.2rem" }}>
                    <h4 className="dialogTitle" style={{ margin: 0, color: '#112a56', lineHeight: 1.4 }}>
                        {props.text}
                    </h4>
                </div>
            </div>
            <DialogActions style={{ justifyContent: "center", paddingTop: '20px', paddingBottom: '8px' }}>
                <Button
                    variant="contained"
                    sx={{
                        height: "46px",
                        minWidth: "140px",
                        borderRadius: '50px',
                        textTransform: 'none',
                        fontWeight: 700,
                        fontSize: '0.95rem',
                        bgcolor: props.type === 'error' ? '#ef4444' : '#16a34a',
                        boxShadow: props.type === 'error' ? '0 4px 12px rgba(239, 68, 68, 0.25)' : '0 4px 12px rgba(22, 163, 74, 0.25)',
                        '&:hover': {
                            bgcolor: props.type === 'error' ? '#dc2626' : '#15803d'
                        }
                    }}
                    onClick={hiddenDialog}
                >
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogConfirmation;